// extracted by mini-css-extract-plugin
export default {"assignmentFormContainer":"Assignment_assignmentFormContainer__sJFNy","assignmentFormContent":"Assignment_assignmentFormContent__NZ+La"};